import { tagsConfig } from '@shared/configs/tags.config';
import { TagsEnum } from '@shared/enums/tags.enum';

export const createTagOptions = () => {
  return [
    tagsConfig[TagsEnum.personal],
    tagsConfig[TagsEnum.garage],
    tagsConfig[TagsEnum.education],
    tagsConfig[TagsEnum.work],
    tagsConfig[TagsEnum.pets],
    tagsConfig[TagsEnum.property],
    tagsConfig[TagsEnum.family],
    tagsConfig[TagsEnum.none],
  ].map((item) => {
    return { label: item.label, value: item.tagId };
  });
};
